var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDuoDislike(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    transform: "rotate(0 0 0)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0937 20.201C10.0937 20.8913 10.6534 21.451 11.3437 21.451H12.07C13.1871 21.451 14.135 20.6313 14.2964 19.5259L14.7342 16.5266C14.7521 16.4038 14.8574 16.3127 14.9815 16.3127L18.3946 16.3127C19.8272 16.3127 20.8949 14.9918 20.5947 13.5911L18.9034 5.70171C18.681 4.66439 17.7642 3.92334 16.7034 3.92334L8.31348 3.92334C8.33989 4.04423 8.35381 4.16979 8.35381 4.29861L8.35381 15.1228C8.35381 15.2116 8.34719 15.2989 8.33442 15.3842L8.8963 15.6816C9.63296 16.0715 10.0937 16.8367 10.0937 17.6702L10.0937 20.201Z",
    fill: "#343C54"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M6.60352 15.873H4.60352C3.91316 15.873 3.35352 15.3134 3.35352 14.623L3.35352 4.79883C3.35352 4.10847 3.91316 3.54883 4.60352 3.54883L6.62284 3.54883C7.02812 3.55908 7.35352 3.89083 7.35352 4.29858L7.35352 15.1228C7.35352 15.537 7.01773 15.873 6.60352 15.873Z",
    fill: "#343C54"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuoDislike);
export default __webpack_public_path__ + "static/media/DuoDislike.880062b9bceca876341e022ff9d6f283.svg";
export { ForwardRef as ReactComponent };